import { connect } from 'react-redux';
import { useEffect, useState, useCallback } from "react";
import { Helmet } from 'react-helmet';

import { Card, Container, Alert, Row, Col } from "reactstrap";

import Circle from 'components/markup/loading/Circle'
import DashHeaderOpen from 'components/markup/headers/DashHeaderOpen'

import _analytics from '_functions/analytics'

import AnalyticsSidebar from '../_components/Sidebar'

const AnalyticsDocuments = ({analytics_query_date, analytics_company}) => {

    const [ data, setData ] = useState(null)
    const [ err, setErr ] = useState(false)

    const fetchData = useCallback(async (_date, company) => {
        setData(null)
        const data = await _analytics.documents(`?timeframe=${_date}&company=${company}`);
        if(data.data) {
            setData(data.data)
        } else {
            setErr('true')
        }
    }, [])

    const onQuery = useCallback(() => {
        fetchData(analytics_query_date, analytics_company)
    }, [fetchData, analytics_query_date, analytics_company])

    useEffect(() => {
        if(!data) fetchData(analytics_query_date, analytics_company)
    }, [fetchData, analytics_query_date, analytics_company, data])

    if(err) {
        return (
            <Container fluid >
                <Alert color="danger">Something went wrong, please refresh your page or try again later.</Alert>
            </Container>
        )
    }

    return (
        <Container fluid>
    
            <Helmet>
                <title>{`Analytics`}</title>
                <meta name="description" content="Analytics" />
            </Helmet>

            <DashHeaderOpen 
                title={<span>Analytics</span>}
                breadcrumb_1={'Documents'}
                icon="fas fa-chart-pie"
            />
    
            <Card className="card-color card-primary table-fixed">

                <Row className="archk-internal-sidebar">

                    <AnalyticsSidebar 
                        onQuery={onQuery}
                        data={data}
                        show={{
                            company: true
                        }}
                    />

                    <Col className="border-left">
                      
                        {!data ? (
                            <div className="py-6"><Circle /></div>
                        ) : (
                            <div className="table-responsive border-bottom">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th className="text-right">Number</th>
                                            <th className="text-right">Percent</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.results ? (
                                            <>
                                            <tr>
                                                <td>Completed</td>
                                                <td className="text-right">{data.results.completed}</td>
                                                <td className="text-right">{((data.results.completed / data.results.total) * 100).toFixed(2)}%</td>
                                            </tr>
                                            <tr>
                                                <td>Failed</td>
                                                <td className="text-right">{data.results.failed}</td>
                                                <td className="text-right">{((data.results.failed / data.results.total) * 100).toFixed(2)}%</td>
                                            </tr>
                                            <tr>
                                                <td>Type: MX</td>
                                                <td className="text-right">{data.results.mx}</td>
                                                <td className="text-right">{((data.results.mx / data.results.total) * 100).toFixed(2)}%</td>
                                            </tr>
                                            <tr>
                                                <td>Type: Yodlee</td>
                                                <td className="text-right">{data.results.yodlee}</td>
                                                <td className="text-right">{((data.results.yodlee / data.results.total) * 100).toFixed(2)}%</td>
                                            </tr>
                                            <tr>
                                                <td>Type: Pinwheel</td>
                                                <td className="text-right">{data.results.pinwheel}</td>
                                                <td className="text-right">{((data.results.pinwheel / data.results.total) * 100).toFixed(2)}%</td>
                                            </tr>
                                            <tr>
                                                <td>First Pulls</td>
                                                <td className="text-right">{data.results.first_pulls}</td>
                                                <td className="text-right">{((data.results.first_pulls / data.results.total) * 100).toFixed(2)}%</td>
                                            </tr>
                                            <tr>
                                                <td>Statements</td>
                                                <td className="text-right">{data.results.statements}</td>
                                                <td className="text-right">{((data.results.statements / data.results.total) * 100).toFixed(2)}%</td>
                                            </tr>
                                            <tr>
                                                <td>Total</td>
                                                <td className="text-right">{data.results.total}</td>
                                                <td className="text-right">100%</td>
                                            </tr>
                                            </>
                                        ) : (
                                            <tr>
                                                <td>No Data To Show</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </Col>

                </Row>
               
            </Card>
        </Container>
    )

}


const mapStateToProps = state => {
	return {
        analytics_company: state.system.analytics_company,
	    analytics_query_date: state.system.analytics_query_date,
	};
};

export default connect(mapStateToProps, '')(AnalyticsDocuments);